import styled, { css } from 'styled-components'

const colorModifier = {
  approved: css`
    background: #e9fce3;
    --dot-color: #4bbf73;
  `,
  waiting: css`
    background: #fdf5e9;
    --dot-color: #e08300;
  `,
  rejected: css`
    background: #fdf6f5;
    --dot-color: #f95d47;
  `
}

export const Pill = styled.span<{
  status: NonNullable<SubpublisherApprovalBadgeProps['status']>
}>`
  display: inline-flex;
  align-items: center;
  gap: 0.4375rem;

  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;

  color: #354052;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  letter-spacing: -0.14px;
  white-space: nowrap;

  ${({ status }) => colorModifier[status]}

  &:before {
    content: '';
    display: inline-block;
    flex-shrink: 0;

    width: 0.5rem;
    height: 0.5rem;
    border-radius: 0.25rem;

    background: var(--dot-color);
  }
`
